<template>
  <div class="edit_container">
    <quill-editor v-model="contentText"
                  ref="QuillEditor"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @change="onEditorChange()">
    </quill-editor>

  </div>
</template>
<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import * as Quill from 'quill'  // 引入编辑器
import ImageResize from 'quill-image-resize-module';
Quill.register('modules/imageResize', ImageResize);


const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],    //加粗，斜体，下划线，删除线                                     
  ['blockquote', 'code-block'],     //引用，代码块
  [{ 'header': 1 }, { 'header': 2 }],        // 标题，键值对的形式；1、2表示字体大小
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],     //列表
  [{ 'script': 'sub' }, { 'script': 'super' }],   // 上下标
  [{ 'indent': '-1' }, { 'indent': '+1' }],     // 缩进
  [{ 'direction': 'rtl' }],             // 文本方向
  [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],     //几级标题
  [{ 'color': [] }, { 'background': [] }],     // 字体颜色，字体背景颜色
  [{ 'font': ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif'] }],     //字体
  [{ 'align': [] }],    //对齐方式
  ['clean'],    //清除字体样式
  ['link', 'image']    //上传图片、上传视频
]
export default {
  props: {
    content: {
      type: String
    },
  },
  components: {
    quillEditor
  },
  data () {
    return {
      contentText: "",
      editorOption: {
        placeholder: "请在这里输入",
        modules: {
          toolbar: {
            container: toolbarOptions,
          },
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          }
        }
      },
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.$nextTick(() => {
        this.contentText = this.content;
      }),
      this.$watch(() => {
        this.contentText = this.content;
      })
    },

    onEditorReady () { // 准备编辑器

    },

    // 失去焦点事件
    onEditorBlur () { },

    // 获得焦点事件
    onEditorFocus (editor) {
      editor.enable(true) // 实现达到上限字符可删除
    },

    // 内容改变事件
    onEditorChange () {
      
    },

    // 转码
    escapeStringHTML (str) {
      str = str.replace(/&lt;/g, '<');
      str = str.replace(/&gt;/g, '>');
      return str;
    },

    handleSuccess (res) {
      // 获取富文本组件实例
      let quill = this.$refs.QuillEditor.quill
      // 如果上传成功
      if (res) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, 'image', res)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        // 提示信息，需引入Message
        console.log('图片插入失败')
      }
    },

  },

  computed: {
    editor () {
      return this.$refs.myQuillEditor.quill;
    },
  }
}
</script>

<style scoped>
.edit_container >>> .ql-container {
  min-height: 400px;
  overflow: hidden;
}
</style>